export const VALORACION_ACCESO_INTEGRO_ID = 1;
export const VALORACION_ACCESO_PERMEABLE_ID = 2;
